// src/vocabulary/A2/unit4/content.js

const content = {
  level: "A2",
  unit: 4,
  title: "Hobbies & Leisure Time",
  description:
    "Common hobbies and free-time activities. Learn how to talk about what you do in your free time.",

  explanation: [
    "This unit focuses on activities people do in their free time.",
    "These words help you talk about hobbies and interests.",
    "In English, we often use verbs like 'play', 'go', and 'watch' with hobbies.",
    "For example: I play football. I watch movies.",
    "You can use time expressions like 'on weekends' or 'in my free time'.",
    "Talking about hobbies helps you connect with other people.",
    "You can also use 'like' and 'enjoy' to talk about activities you love.",
    "Try to talk about what you do after work or school."
  ],

  items: [
    {
      word: "play football",
      phonetic: "/pleɪ ˈfʊtbɔːl/",
      meaning: "يلعب كرة قدم",
      example: "I play football on weekends."
    },
    {
      word: "watch movies",
      phonetic: "/wɒtʃ ˈmuːviz/",
      meaning: "يشاهد أفلام",
      example: "She watches movies in the evening."
    },
    {
      word: "listen to music",
      phonetic: "/ˈlɪsən tuː ˈmjuːzɪk/",
      meaning: "يستمع إلى الموسيقى",
      example: "I listen to music when I relax."
    },
    {
      word: "read books",
      phonetic: "/riːd bʊks/",
      meaning: "يقرأ كتب",
      example: "He reads books before sleeping."
    },
    {
      word: "go out",
      phonetic: "/ɡoʊ aʊt/",
      meaning: "يخرج",
      example: "We go out with friends on Fridays."
    },
    {
      word: "travel",
      phonetic: "/ˈtrævəl/",
      meaning: "يسافر",
      example: "They travel during the summer."
    }
  ]
};

export default content;


